import React from 'react';
import { cn } from '../ui-x';

/**
 * The reference's secondary button: outline in navy.
 * The old base string was `${className && className}border-primary` — with no
 * separating space, so a className glued itself onto the next class.
 */
const OutlineButton = ({ label, className, onClick, type = 'button', disabled }) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={cn(
        'inline-flex h-9 items-center justify-center whitespace-nowrap rounded-lg border border-brand-navy px-4 text-sm font-semibold text-brand-navy transition-colors hover:bg-surface',
        'disabled:pointer-events-none disabled:opacity-50',
        className
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default OutlineButton;
